import CheckSharpIcon from '@mui/icons-material/CheckSharp'
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp'
import { IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../utils/hooks'

interface CopyButtonProps {
  value: string
  translationKey?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, translationKey = 'copyIdentifier' }) => {
  const { t } = useTranslation('caseProperty')
  const { setNotification } = useNotification()
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async () => {
    if (!value) {
      setNotification({
        message: t(`${translationKey}.error`),
        open: true,
        variant: 'error'
      })
      return
    }

    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setNotification({
        message: t(`${translationKey}.success`),
        open: true,
        variant: 'success'
      })
      window.setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (error) {
      setNotification({
        message: t(`${translationKey}.error`),
        open: true,
        variant: 'error'
      })
      console.error(t(`${translationKey}.error`), error)
    }
  }

  return (
    <Tooltip title={t(`${translationKey}.copy`)} placement="top">
      <IconButton size="small" onClick={copyToClipboard}>
        {copied ? <CheckSharpIcon /> : <ContentCopySharpIcon />}
      </IconButton>
    </Tooltip>
  )
}

export default CopyButton
